import { useEffect } from 'react'
import { useBranding } from '../contexts/BrandingContext'
import { API_URL } from '../server'

/** OriginsDirect default: sign.png. Never use the OR favicon (favicon.svg). */
const DEFAULT_FAVICON = '/sign.png'

/**
 * Updates the document favicon based on branding.
 * In group mode: uses group favicon if set, otherwise group logo.
 * Otherwise (OriginsDirect, not in groups, or admins to manufacturers): uses sign.png.
 */
const FaviconUpdater = () => {
  const { isGroupMode, logo, favicon } = useBranding()

  useEffect(() => {
    // Get the custom favicon/logo URL, using the exact same logic as PharmacyGroupsTable
    let customHref = null
    if (isGroupMode && (favicon || logo)) {
      const url = favicon || logo
      // Use the exact same pattern as PharmacyGroupsTable (lines 557-559, 601-603)
      customHref = url.startsWith('http')
        ? url
        : `${(API_URL || '').replace(/\/api\/?$/, '')}${url.startsWith('/') ? '' : '/'}${url}`
    }
    
    const href = customHref || DEFAULT_FAVICON
    
    // Always apply cache-busting for custom favicons to prevent browser caching issues
    const hrefWithCache = customHref 
      ? `${href}${href.includes('?') ? '&' : '?'}v=${Date.now()}`
      : href

    // Remove ALL existing favicon-related link elements to prevent duplicate requests
    // This includes: icon, shortcut icon, apple-touch-icon, etc.
    const existingLinks = document.querySelectorAll('link[rel*="icon"], link[rel*="shortcut"]')
    existingLinks.forEach((link) => {
      link.remove()
    })

    // Create a fresh favicon link element with proper attributes
    const link = document.createElement('link')
    link.rel = 'icon'
    link.href = hrefWithCache
    link.type = href.endsWith('.svg') ? 'image/svg+xml' : (href.endsWith('.png') ? 'image/png' : 'image/x-icon')
    
    // Append to head - browsers will fetch the new favicon
    document.head.appendChild(link)
    
    // Also create a shortcut icon link for better browser compatibility
    if (customHref) {
      const shortcutLink = document.createElement('link')
      shortcutLink.rel = 'shortcut icon'
      shortcutLink.href = hrefWithCache
      shortcutLink.type = href.endsWith('.svg') ? 'image/svg+xml' : (href.endsWith('.png') ? 'image/png' : 'image/x-icon')
      document.head.appendChild(shortcutLink)
    }
  }, [isGroupMode, logo, favicon])

  return null
}

export default FaviconUpdater